// export const SET_BYAGE_LAYER = 'SET_BYAGE_LAYER';
// export const setByAgeLayer= (layer) => {
//     return {type:'SET_BYAGE_LAYER',payload:layer}
// };

export const SIGN_IN = 'SIGN_IN';
export const logIn= (username='',password='') => {
    return async (dispatch) => {
        let res=await fetch('https://map.pdxoptions.com/zillowbackend/pdx-login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username: username, password: password })
        })
        let data
        console.log(res.ok)
        if (res.ok) {
            // Extract and return the authentication token from the response
            data = true
        } else {
            data= false
        }
        dispatch({type:'SIGN_IN',payload:data})
        return {type:'SIGN_IN',payload:data}
    }
};
